import styled from "@emotion/styled";
import { units } from "../../../types/units";
import { HEADER_MIN_HEIGHT } from "../../../utils/constants";

export const MainWrapper = styled.div`
  border-bottom: 1px solid;
  width: 100%;
  display: flex;
  position: sticky;
  top: 0;
  min-height: ${HEADER_MIN_HEIGHT}px;
  justify-content: space-between;
  padding-left: 2rem;
  z-index: 20;
  font-family: ${(props) => props.theme.fontFamily.primary};
  ${units({
    color: "black",
    backgroundColor: "lynxWhite",
    borderColor: "lightGrey",
  })};
`;

export const LeftCol = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const RightCol = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const IconWrapper = styled.span`
  margin-right: 15px;
`;
